import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=df9f82aa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=df9f82aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9f82aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9f82aa')) {
      api.createRecord('df9f82aa', component.options)
    } else {
      api.reload('df9f82aa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=df9f82aa&scoped=true&", function () {
      api.rerender('df9f82aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ij2udNXGGHIr/JS/comp/PopupBox.vue"
export default component.exports